function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "SVGID_1_",
  cx: 80,
  cy: 80,
  r: 80
}));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var SvgConoceObsHome = function SvgConoceObsHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4E7FF"
    },
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("g", null, _ref2, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.871,
    y: 68.549,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.729,
    height: 39.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.271,
    y: 75.573,
    style: {
      fill: "#92C5C9"
    },
    width: 25.927,
    height: 25.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 68.549,
    style: {
      fill: "#919191"
    },
    width: 15.123,
    height: 39.97
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C8E2E4"
    },
    points: "63.271,101.498 69.753,101.498 89.197,75.573 82.716,75.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ADD4D7"
    },
    points: "69.753,101.498 76.233,101.498 89.197,84.213 89.197,75.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B7BC"
    },
    points: "76.233,101.498 82.716,101.498 89.197,92.855 89.197,84.213  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE99CC"
    },
    d: "M113.021,56.749c0-6.903,5.596-12.5,12.498-12.5c6.903,0,12.498,5.597,12.498,12.5 c0,1.828,0,25.146,0,25.146h-16.776l-0.039-7.357h-5.021v-7.971h-3.16C113.021,66.567,113.021,58.577,113.021,56.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5007F"
    },
    d: "M121.369,81.66h16.52c6.688,0,12.111,5.422,12.111,12.115v66.807h-40.742V93.775 C109.258,87.082,114.681,81.66,121.369,81.66z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EE99CC"
    },
    cx: 116.422,
    cy: 105.144,
    r: 6.372
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.197,
    y: 103.135,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 110.4576 -46.674)",
    style: {
      fill: "#EE99CC"
    },
    width: 12.744,
    height: 13.725
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EE99CC"
    },
    cx: 106.43,
    cy: 114.892,
    r: 6.372
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EE99CC"
    },
    cx: 81.921,
    cy: 114.892,
    r: 6.372
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.921,
    y: 108.52,
    style: {
      fill: "#EE99CC"
    },
    width: 24.508,
    height: 12.744
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EDEDED"
    },
    cx: 128.206,
    cy: 93.359,
    r: 6.372
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.942,
    y: 90.918,
    transform: "matrix(0.7072 0.707 -0.707 0.7072 105.989 -57.4173)",
    style: {
      fill: "#EDEDED"
    },
    width: 12.743,
    height: 16.666
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M125.52,44.249c6.903,0,12.498,5.597,12.498,12.5c0,0.904,0,7.076,0,13.078l-7.093-8.381 c1.624,0,2.941-1.317,2.941-2.941s-1.317-2.941-2.941-2.941s-2.94,1.317-2.94,2.941c0,0-4.299-0.707-7.864-2.553 c-3.564-1.846-5.903-4.514-5.903-4.514C116.215,47.194,120.518,44.249,125.52,44.249z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 67.59,
    cy: 66.199,
    r: 8.333
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 67.59,
    cy: 66.2,
    r: 6.448
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.093,
    y: 72.295,
    transform: "matrix(-0.9563 -0.2923 0.2923 -0.9563 105.389 164.9665)",
    style: {
      fill: "#242424"
    },
    width: 1.851,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 74.771,
    transform: "matrix(-0.9565 -0.2918 0.2918 -0.9565 99.5256 177.3488)",
    style: {
      fill: "#242424"
    },
    width: 2.778,
    height: 12.963
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE99CC"
    },
    d: "M52.898,56.176c1.244-6.399-2.935-12.596-9.336-13.841c-6.398-1.243-12.596,2.937-13.84,9.337 c-0.329,1.695-4.531,23.314-4.531,23.314l15.555,3.023l1.36-6.814l4.655,0.906l1.437-7.393l2.931,0.57 C51.129,65.28,52.569,57.872,52.898,56.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5007F"
    },
    d: "M40.668,77.77l-15.316-2.977c-6.201-1.205-12.206,2.844-13.411,9.048L0,145.277l37.771,7.342 l11.942-61.438C50.92,84.979,46.87,78.975,40.668,77.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE99CC"
    },
    d: "M40.668,77.77c-1.626-1.834-2.581-5.023-6.811-5.846c-4.229-0.822-8.037,0.463-8.505,2.869 c-0.25,1.283,3.371,4.891,7.749,8.152c3.627,2.701,9.188,4.922,11.9,3.279C47.714,84.584,42.591,79.938,40.668,77.77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M43.563,42.335c-6.398-1.243-12.596,2.937-13.84,9.337c-0.163,0.838-1.274,6.559-2.357,12.125 l8.087-6.491c-1.505-0.293-2.489-1.751-2.196-3.257c0.292-1.507,1.751-2.49,3.256-2.197c1.507,0.293,2.489,1.752,2.197,3.256 c0,0,4.112,0.12,7.751-0.949c3.637-1.068,6.286-3.119,6.286-3.119C51.659,46.744,48.2,43.239,43.563,42.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M28.876,56.027c0,0-3.857,19.839-4.187,21.538c-0.333,1.705-1.431,3.066-2.866,3.8 c0.769,0.889,1.825,1.537,3.067,1.779c2.947,0.572,5.802-1.354,6.375-4.3l4.187-21.538L28.876,56.027z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EE99CC"
    },
    cx: 39.497,
    cy: 100.751,
    r: 6.019
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.147,
    y: 97.41,
    transform: "matrix(-0.4849 0.8746 -0.8746 -0.4849 157.9275 114.7666)",
    style: {
      fill: "#EE99CC"
    },
    width: 12.037,
    height: 12.965
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EE99CC"
    },
    cx: 50.795,
    cy: 107.047,
    r: 6.019
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE99CC"
    },
    d: "M66.032,88.609c1.405-3.012,0.103-6.59-2.91-7.996c-3.014-1.404-6.593-0.104-7.997,2.91 c-1.408,3.016-0.102,6.594,2.909,8C61.047,92.926,64.628,91.623,66.032,88.609z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.669,
    y: 84.982,
    transform: "matrix(0.9063 0.4226 -0.4226 0.9063 46.0239 -14.4877)",
    style: {
      fill: "#EE99CC"
    },
    width: 12.034,
    height: 23.148
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EDEDED"
    },
    cx: 25.73,
    cy: 93.119,
    r: 6.018
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.596,
    y: 89.066,
    transform: "matrix(-0.4846 0.8747 -0.8747 -0.4846 133.2117 115.3839)",
    style: {
      fill: "#EDEDED"
    },
    width: 12.037,
    height: 15.739
  }))))), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConoceObsHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conoceObsHome.6d35ead0.svg";
export { ForwardRef as ReactComponent };